import React from "react";
import styles from "./video-highlight.module.css";
import { setText } from "../../../Redux/Actions/VideoHighlightAction";
import { useSelector, useDispatch } from "react-redux";
function TextBox() {
  const dispatch = useDispatch();
  const text = useSelector((state) => state?.videoHighlightData?.text);
  const handleTextChange = (event) => {
    setText(dispatch, event.target.value);
  };
  return (
    <div>
      <div className={styles.textBoxWrapper}>
        <input
          type="text"
          value={text}
          onChange={handleTextChange}
          className={styles.textBox}
          placeholder="Tap Here"
        />
      </div>
    </div>
  );
}

export default TextBox;
